import Flickity from 'flickity';

const initAboutSliders = (els) => {
    els.forEach((el) => {
        const subSliders = el.querySelectorAll('.js-about-subslider');
        const sliders = [];
        const controls = el.querySelectorAll('.js-control');

        subSliders.forEach((subslider) => {
            const flkty = new Flickity(subslider, {
                cellSelector: '.js-cell',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                draggable: false,
                autoplay: false,
                pauseAutoPlayOnHover: false,
            });

            sliders.push(flkty);
        });

        controls.forEach((button) => {
            const { dir } = button.dataset;
            button.addEventListener('click', () => {
                if (dir === 'prev') {
                    sliders.forEach((slider) => {
                        slider.previous();
                    });
                } else {
                    sliders.forEach((slider) => {
                        slider.next();
                    });
                }
            })
        })
    });
};

export default initAboutSliders;
